<template>
    <div class="grade_item-container">
        <h2 class="grade_item-name">Аналитика прохождения заданий по дисциплинам</h2>
        <ResultsBySubjectChart ref="chart" :height="385" :loading="loading" />
        <v-btn @click="showFullChart" :loading="loading" class="btn">Развернуть</v-btn>
        <ResultsBySubjectDialog ref="dialog" :categories="categories.full" :series="series.full" />
    </div>
</template>

<script>
import ResultsBySubjectChart from './chart.vue';
import ResultsBySubjectDialog from './dialog.vue';

const PreviewCount = 10;

export default {
    name: 'ResultsBySubject',
    components: { ResultsBySubjectChart, ResultsBySubjectDialog },
    props: {
        loading: Boolean
    },
    data: () => ({
        categories: {
            full: [],
            preview: []
        },
        series: {
            full: [],
            preview: []
        },
    }),
    methods: {
        update(data) {
            this.categories.full = data.map(x => x.subjectName);
            this.categories.preview = this.categories.full.slice(0, PreviewCount);

            this.series.full = data.map(x => x.count);
            this.series.preview = this.series.full.slice(0, PreviewCount);

            this.$refs.chart.update(this.categories.preview, this.series.preview);
        },
        showFullChart() {
            this.$refs.dialog.open();
        }
    }
}
</script>
